import React from "react";

const ContactTwoForm = ({lang}) => {
  return (
    <div className="contact-form-wrap-two wow fadeInRight" data-wow-delay=".2s">
      <h2 className="title">{lang.data.Support.Header.n04}</h2>
      <form action="#">
        <input type="text" placeholder="Name" required />
        <input type="email" placeholder="Email Address" required />
        <textarea name="massage" placeholder="Massage" required></textarea>
        <button type="submit" className="btn btn-two">
        {lang.data.Support.Header.n05}
        </button>
      </form>
    </div>
  );
};

export default ContactTwoForm;
